import { render, staticRenderFns } from "./SurveyDone.vue?vue&type=template&id=04a30ca2&scoped=true&"
import script from "./SurveyDone.vue?vue&type=script&lang=js&"
export * from "./SurveyDone.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDone.vue?vue&type=style&index=0&id=04a30ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a30ca2",
  null
  
)

export default component.exports